var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-order-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var brief = ref.brief;
var isLoading = ref.isLoading;
var order = ref.order;
var products = ref.products;
return [(brief && order)?_c('activation-brief-order-view',{attrs:{"brief":brief,"order":order,"products":products}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }